import {SODeleteInvoice} from '../../core/invoice/so-delete-invoice';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteInvoice extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteInvoice;
}